import config from "../..//services/config";

class BaseDrawingObject {
    constructor() {
        this.alwaysRedraw = false;
        this.drawingGroupName = config.CHASSIS_OBJECT_TYPES.VEHICLE;
    }

    getAlwaysRedraw() {
        return this.alwaysRedraw;
    }

    setAlwaysRedraw(value) {
        this.alwaysRedraw = Boolean(value);
        return this;
    }

    
    setDrawingGroupName(group) {
        this.drawingGroupName = group;
        return this;
    }

    setParentDrawingGroupName(group) {
        this.parentDrawingGroupName = group;
        return this;
    }

    setLinkedInteractionId(linkedInteractionId) {
        this.linkedInteractionId = linkedInteractionId;
        return this;
    }

    getLinkedInteractionId() {
        return this.linkedInteractionId;
    }

    setMenuPath(menuPath) {
        this.menuPath = menuPath;
        return this;
    }

    getMenuPath() {
        return this.menuPath;
    }

    setBringToFront(newValue) {
        this.bringToFront = newValue;
        return this;
    }

    setPreventDefaultFillWhenGrouped(newValue) {
        this.preventDefaultFillWhenGrouped = Boolean(newValue);
        return this;
    }

    setLineWidth(newValue) {
        this.lineWidth = newValue;
        return this;
    }

    setApplyTintToFillGraphicsObject(newValue) {
        this.applyTintToFillGraphicsObject = Boolean(newValue);
        return this;
    }

    getApplyTintToFillGraphicsObject() {
        return this.applyTintToFillGraphicsObject;
    }
            
}

export default BaseDrawingObject;
